import { NgModule } from '@angular/core';
import { CoreCacheModule } from '../../Core/Cache/cache.module';
import { JournodexApiService } from '../../api/journodex/journodex.api.service';
import { JournodexRegionsService } from './services/journodex-regions.service';
import { JournodexSubjectsService } from './services/journodex-subjects.service';

@NgModule({
    imports: [
        CoreCacheModule,
    ],
    exports: [
    ],
    providers: [
        JournodexApiService,
        JournodexRegionsService,
        JournodexSubjectsService
    ]
})
export class JournodexModule { }
